import { cssToken } from "@certn/cascadia";
import { CascadiaLayout } from "@certn/cascadia-tokens";
import { css, cx } from "@emotion/css";
import React, { CSSProperties } from "react";

import { useLayout } from "./Layout";
import { mq } from "../../components/utils";

export interface GridProps {
  "aria-label"?: string;
  children?: React.ReactNode;
  className?: string;
  form?: boolean;
  layout?: CascadiaLayout;
  testID?: string;
  width?: CSSProperties["width"];
}

export function Grid(props: GridProps) {
  const { className, children, form, testID = "grid", layout, width } = props;
  const {
    layoutValues: { columns, gapHorizontal, gapVertical },
  } = useLayout(layout);

  return (
    <section
      aria-label={props["aria-label"]}
      className={cx(
        styles.grid,
        css(
          {
            gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
            gridColumnEnd: columns,
            "> :not(.grid-item)": {
              gridColumnStart: 1,
              gridColumnEnd: columns + 1,
            },
          },
          mq({
            width: ["100%", width],
          }),
          form
            ? styles.formGrid
            : mq({
                columnGap: gapHorizontal.map(cssToken),
                rowGap: gapVertical.map(cssToken),
              })
        ),
        className
      )}
      data-testid={testID}
    >
      {children}
    </section>
  );
}

const styles = {
  grid: css({
    display: "grid",
    "> :not(.grid-item)": {
      gridColumnStart: 1,
      gridColumnEnd: 12 + 1,
    },
  }),
  formGrid: css({
    columnGap: "var(--space-2)",
    rowGap: "var(--space-6)",
  }),
};
